<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9.56202 12.6204L2 3H7.98966L12.6576 8.94606L17.6446 3.02677H20.9434L14.2526 10.9777L22.186 21.0833H16.2143L11.1598 14.653L5.76365 21.0655H2.44699L9.56202 12.6204ZM17.0847 19.3008L5.67266 4.78249H7.11855L18.5162 19.3008H17.0847Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
